import React, { useEffect } from "react";
import useStore from "../../store";
import { useNavigate } from "react-router-dom";
import withAuth from "../Auth/withAuth";

function LXE() {
  const navigate = useNavigate();

  const { logout, setPageTitle, isLoggedIn, data, tenantId } = useStore(
    (state) => state
  );

  useEffect(() => {
    setPageTitle("Learning Experience Exchange");
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      logout();
      navigate(`/?tenantId=${tenantId}`);
    }
  }, []);

  return (
    <div>
      <iframe
        title="my-iframe"
        width="100%"
        height="1000px"
        src={`https://lxe.eduedges.com/Questions?id_token=${data.idToken.jwtToken}&access_token=${data.accessToken.jwtToken}&tenant_id=${tenantId}`}
      ></iframe>
    </div>
  );
}

export default withAuth(LXE);
